import useAppStore from '../../store/appStore';
import { resolveEffectiveClientMwstSatz } from '../../store/slices/settingsSlice';

export interface PeInvoiceVatContext {
  isVatExempt: boolean;
  standardRate: number;
  activeLand: string;
}

/**
 * MwSt für PEInvoice ausschließlich aus App-Store:
 * - Umsatzsteuerbefreiung (Stammdaten & CH Art. 10 MWSTG < 100'000 CHF)
 * - Ländersatz settings.country.MwSt_Satz
 */
export function getPeInvoiceVatFromAppStore(): PeInvoiceVatContext {
  const state = useAppStore.getState() as any;
  const cd = state?.clientData || {};
  const nested = cd.clientData || {};
  const settings = state?.settings || {};

  const rawLand =
    cd.Land ||
    cd.land ||
    nested.Land ||
    nested.land ||
    settings.selectedCountryId ||
    'DE';

  let activeLand = String(rawLand).toUpperCase().trim();
  if (activeLand.includes('DEUTSCHLAND')) activeLand = 'DE';
  else if (activeLand.includes('ÖSTERREICH') || activeLand.includes('OESTERREICH') || activeLand === 'AT')
    activeLand = 'AT';
  else if (activeLand.includes('SCHWEIZ') || activeLand === 'CH') activeLand = 'CH';
  else if (activeLand.includes('ITALIEN') || activeLand === 'IT') activeLand = 'IT';
  else if (!['DE', 'AT', 'CH', 'IT'].includes(activeLand)) activeLand = 'DE';

  const effectiveRate = resolveEffectiveClientMwstSatz(settings, cd);
  const isVatExempt = effectiveRate === 0;
  const standardRate = effectiveRate;

  return { isVatExempt, standardRate, activeLand };
}
